var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('b-overlay',{attrs:{"show":_vm.$root.loading,"rounded":"sm"}},[_c('router-view')],1),_c('div',{staticClass:"version"},[_vm._v(_vm._s(_vm.version))])],1),(_vm.homolog || _vm.development)?_c('div',{staticClass:"env-tag",class:{ dev: _vm.development }}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }